import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { DocumentStatusEnum, type DocumentRecord } from '../../models';
import { AccessBannerComponent } from '../access-banner/access-banner';

const REVIEW_STATUSES = new Set([
  DocumentStatusEnum.DRAFT,
  DocumentStatusEnum.AWAITING_APPROVAL,
  DocumentStatusEnum.REJECTED,
]);

const MESSAGES = {
  review_required: 'document_grounding.review_required',
  no_evidence: 'document_grounding.no_evidence',
  index_pending: 'document_grounding.index_pending',
  context_unavailable: 'document_grounding.context_unavailable',
  unknown: 'document_grounding.unknown',
  not_permitted: 'document_grounding.not_permitted',
  selected_sources_excerpted: 'document_grounding.selected_sources_excerpted',
  regulatory_unavailable: 'document_grounding.regulatory_unavailable',
  regulatory_no_evidence: 'document_grounding.regulatory_no_evidence',
} as const;

@Component({
  selector: 'app-document-grounding-notice',
  imports: [AccessBannerComponent, TranslocoModule],
  styleUrl: './document-grounding-notice.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @for (key of messageKeys(); track key) {
      <app-access-banner
        [fullWidth]="true"
        [notice]="{ message: key | transloco, icon: 'info', tone: 'info' }"
      />
    }
  `,
})
export class DocumentGroundingNoticeComponent {
  readonly grounding = input<DocumentRecord['generation_grounding']>();
  readonly documentStatus = input<DocumentRecord['status']>();
  protected readonly messageKeys = computed(() => {
    const grounding = this.grounding();
    if (!grounding) return [];
    const reasons = new Set([
      ...(grounding.status === 'ready' ? [] : [grounding.status]),
      ...grounding.warnings,
    ]);
    const status = this.documentStatus();
    if (!reasons.size)
      return status && REVIEW_STATUSES.has(status) ? [MESSAGES.review_required] : [];
    return [
      ...new Set(
        [...reasons].map(reason => MESSAGES[reason as keyof typeof MESSAGES] ?? MESSAGES.unknown)
      ),
    ];
  });
}
